module.exports = __webpack_public_path__ + "static/img/yytx05.21cdbd4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx05.png
// module id = 877
// module chunks = 0